import clsx from 'clsx';

import Icon from '../Icon';
import { notify } from '../../shared';

export const onCopy = () => notify.success('Text copied successfully.');
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);

    onCopy();
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
};

type CopyProps = {
  text?: string;
  label?: string;
  className?: string;
};

export const Copy: React.FC<CopyProps> = ({ text, label, className }) => {
  return (
    <span
      onClick={text ? () => copyToClipboard(text) : undefined}
      className={clsx(
        className,
        text ? 'cursor-pointer' : '',
        label ? 'flex items-center gap-x-sm' : ''
      )}
    >
      <Icon icon="copy" />
      {label && <div className="shrink-0">{label}</div>}
    </span>
  );
};
